import { Component, ChangeDetectionStrategy } from '@angular/core'
import { GbSidenavItem } from 'libs/gb-dashboard/core/feature/src/lib/gb-dashboard-sidenav/gb-dashboard-sidenav.component'
import { IconLibrary } from 'libs/gb-dashboard/shared/ui/src/lib/gb-icon/gb-icon-library.models'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { StaffConstants } from '../staff.constants'
import { GbDashboardAuthService } from 'libs/gb-dashboard/account/utils/src/lib/gb-dashboard-auth-service/gb-dashboard-auth.service'

@Component({
  selector: 'gb-staff',
  templateUrl: './gb-staff.component.html',
  styleUrls: ['./gb-staff.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GbStaffComponent {
  staffSidenavItems: GbSidenavItem[] = [
    {
      isDivider: false,
      icon: 'notifications_active',
      iconLibrary: IconLibrary.material,
      label: 'STAFF.SIDENAV.ANNOUNCEMENTS',
      routerLink: StaffConstants.ANNOUNCEMENTS,
      subItems: null,
    },
    {
      isDivider: false,
      icon: 'documents',
      iconLibrary: IconLibrary.ionic,
      label: 'STAFF.SIDENAV.REPORTS',
      routerLink: StaffConstants.REPORTS,
      subItems: null,
    },
    {
      isDivider: false,
      icon: 'play-circle',
      iconLibrary: IconLibrary.ionic,
      label: 'STAFF.SIDENAV.TUTORIAL_VIDEOS',
      routerLink: StaffConstants.TUTORIAL_VIDEOS,
      subItems: null,
    },
    {
      isDivider: false,
      icon: 'people',
      iconLibrary: IconLibrary.ionic,
      label: 'STAFF.SIDENAV.USER_ACCOUNTS',
      routerLink: StaffConstants.USER_ACCOUNTS,
      subItems: null,
    },
    {
      isDivider: false,
      icon: 'cog',
      iconLibrary: IconLibrary.ionic,
      label: 'STAFF.SIDENAV.SYSTEM',
      routerLink: StaffConstants.AWS,
      subItems: null,
    },
  ]

  constructor(private gbDashboardAuthService: GbDashboardAuthService) {}

  staffSidenavItems$: Observable<GbSidenavItem[]> = of(null).pipe(
    map(() => {
      if (this.gbDashboardAuthService.isDistributor() && !this.gbDashboardAuthService.isStaff()) {
        // Distributors can only see user accounts
        return this.staffSidenavItems.filter((item) => item.routerLink === StaffConstants.USER_ACCOUNTS)
      }
      return this.staffSidenavItems
    }),
  )
}
